import React from "react";

interface IconCheckProps {
  width?: string;
  height?: string;
  fill?: string;
}

const IconLocation: React.FC<IconCheckProps> = ({
  width = "20px",
  height = "20px",
  fill = "#f7f5f5",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-list"
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />{" "}
  </svg>
);
export default IconLocation;
